import Spinner from 'components/Spinner';
import { FC } from 'react';
import { Button, ButtonProps } from 'react-bootstrap';
type ButtonWithLoadingProps = ButtonProps & { isLoading: boolean; label?: string; disableWhileLoading?: boolean;};

export const ButtonWithLoading: FC<ButtonWithLoadingProps> = ({ isLoading, label, disableWhileLoading = false, ...props }) => {
    const isDisabled = props.disabled || (disableWhileLoading && isLoading);
    return (
        <>
            <Button {...props} disabled={isDisabled} >
                {!isLoading ?
                    label || props.children
                    : 
                    <Spinner className="spinner-border-sm" tag="span" color="white" />
                }
            </Button>
        </>
    );
};
